import type { Ref } from "vue";
import type { User } from "@/user/store/baseDataStore.ts";
import { ref } from "vue";

const appUser: Ref<User | null> = ref(null)

export function useAppUser () {

    function get() {
        return appUser
    }

    function set(user: User | null) {
        appUser.value = user
    }

    function isShallow() {
        return appUser.value ? appUser.value.isShallow : false
    }

    return {
        get,
        set,
        isShallow
    }

}
